/*
Sohel 01/09/2023 2698951347 Implemented Copy Functionality
Sohel 01/18/2023 2698951347 Fixed Payload Issue
Sohel 01/02/2023 2698951347 fixed code uppercase issue
Rohini 03/02/2023 2698951347 commented input props
sohel 03/06/2023 2698951347 Added validation message for existing value
Ravi 06/23/2023 2698951347 fixed submit issue
*/
import React, {useEffect, useRef, useContext} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {useDispatch, useSelector} from 'react-redux';
import {codeRegex} from '../../../util/RegexPatterns';
import {codeValidationMessage} from '../../../util/Content';
import BreadCrums from '../../../util/BreadCrum';
import {fetchAllExportCode, postCopy} from '../../../redux/reducers/EDI/';
import {upperCaseCode} from '../../../components/UpperCaseCode';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';
import {NumberFormatter} from '../../../components/UserDefinedForm/AppTextInputComponents';
import {ThemeContext} from '../../../themes/ThemeProvider';

const CopyDataManager = ({oldDmCodeData, type}) => {
  const {allExportCode} = useSelector(({ediExport}) => ediExport);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const initialValues = {
    code: '',
    description: '',
    interchangeControlNumber: '',
  };
  const codeRef = useRef();
  const checkCodeExist = (value) => {
    if (allExportCode && allExportCode?.length > 0 && value) {
      const ar = [];
      allExportCode.filter((i) => {
        if (
          i?.exportCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkDataMangerCodeAlreadyExist = (value) => {
    if (allExportCode && allExportCode?.length > 0 && value) {
      const ar = [];
      allExportCode.filter((i) => {
        if (
          i?.exportCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkNumberExist = (value) => {
    if (allExportCode && allExportCode?.length > 0 && value) {
      const ar = [];
      allExportCode.filter((i) => {
        if (
          i?.interchangeControlNumber?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkNumberAlreadyExist = (value) => {
    if (allExportCode && allExportCode?.length > 0 && value) {
      const ar = [];
      allExportCode.filter((i) => {
        if (
          i?.interchangeControlNumber?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const schema = Yup.object().shape({
    code: Yup.string()
      .required('Code is required')
      .matches(codeRegex, codeValidationMessage)
      .test('code', 'Code already exist', (value) => !checkCodeExist(value))
      .test(
        'code',
            `Code has already been used in the past`,
            (value) => !checkDataMangerCodeAlreadyExist(value),
      ),

    description: Yup.string()
      .test('description', 'Description is required', (value) => {
        return value?.replaceAll(' ', '');
      })
      .required('Description is required'),
    interchangeControlNumber: Yup.string()
      .test('interchangeControlNumber', 'Interchange Control Number is required', (value) => {
        return value?.replaceAll(' ', '');
      })
      .required('Interchange Control Number is required')
      .test('code', 'Interchange Control Number already exist', (value) => !checkNumberExist(value))
      .test(
        'code',
            `Interchange Control Number has already been used in the past`,
            (value) => !checkNumberAlreadyExist(value),
      ),
  });
  const handleSubmit = (values) => {
    if (values) {
      dispatch(submissionStart());
      const data = {
        newExportCode: values?.code ? values?.code?.toUpperCase() : '',
        newExportDescription: values?.description ? values?.description : '',
        exportCode: oldDmCodeData?.exportCode ? oldDmCodeData?.exportCode : '',
        newInterChangeControlNumber: values?.interchangeControlNumber ?
          values?.interchangeControlNumber :
          '',
      };
      dispatch(postCopy(data));
    }
  };
  useEffect(() => {
    dispatch(fetchAllExportCode());
  }, []);

  return (
    <>
      <div className={classes.addRule}>
        <div className={classes.dialoguecardStyles}>
          <Formik
            onSubmit={(values) => handleSubmit(values)}
            initialValues={initialValues}
            validationSchema={schema}
            enableReinitialize
            validateOnChange
          >
            {(props) => {
              const {
                values,
                handleSubmit,
                handleReset,
                handleChange,
                touched,
                errors,
                resetForm,
                handleBlur,
                setFieldValue,
              } = props;
              return (
                <div>
                  <BreadCrums
                    name={'Code'}
                    code={oldDmCodeData?.exportCode}
                    description={'Description'}
                    descriptionValue={oldDmCodeData?.exportDescription}
                  />
                  <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                    <div className="global-field-textfields new-standard-textfields">
                      <ErrorBoundaryForComponents>
                        <Grid container spacing={2}>
                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Code"
                              margin="dense"
                              name="code"
                              variant="outlined"
                              value={values?.code}
                              inputRef={codeRef}
                              label="Code"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              required
                              onBlur={handleBlur}
                              onChange={(e) => {
                                const value = upperCaseCode(codeRef);
                                setFieldValue('code', value);
                              }}
                              touched={touched.code}
                              error={Boolean(errors.code && touched.code)}
                              fullWidth
                            />
                            <FormHelperText style={{color: 'red'}} variant="outlined">
                              {touched.code && errors.code}
                            </FormHelperText>
                          </Grid>

                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Description"
                              margin="dense"
                              name="description"
                              value={values.description}
                              variant="outlined"
                              label="Description"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                setFieldValue('description', e.target.value);
                              }}
                              touched={touched.description}
                              required
                              error={Boolean(errors.description && touched.description)}
                              fullWidth
                            />
                            <FormHelperText variant="outlined">
                              {touched.description && errors.description}
                            </FormHelperText>
                          </Grid>
                          <Grid item xs={6} className="form-group">
                            <TextField
                              className={` ${classes.labelName}`}
                              margin="dense"
                              variant="outlined"
                              placeholder={`Enter Interchange Control Number `}
                              label={`Interchange Control Number`}
                              name="interchangeControlNumber"
                              value={values.interchangeControlNumber}
                              onChange={handleChange}
                              InputProps={{
                                inputComponent: NumberFormatter,
                              }}
                              onBlur={handleBlur}
                              fullWidth
                              required
                              touched={touched.interchangeControlNumber}
                              error={Boolean(
                                touched.interchangeControlNumber && errors.interchangeControlNumber,
                              )}
                            />
                            <FormHelperText>
                              {touched.interchangeControlNumber &&
                                errors?.interchangeControlNumber &&
                                errors.interchangeControlNumber}
                            </FormHelperText>
                          </Grid>
                        </Grid>
                      </ErrorBoundaryForComponents>
                    </div>
                    <div className="button-spacing-mb new-standard-textfields">
                      <Button
                        variant="outlined"
                        onClick={() => {
                          resetForm(initialValues);
                        }}
                        className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn ml-1 ${classes.buttonRoot}`}
                        disabled={enabledSubmission}
                      >
                        Copy
                      </Button>
                    </div>
                  </form>
                </div>
              );
            }}
          </Formik>
        </div>
      </div>
      {/* {isBasicInfoLoading && <PageLoader />} */}
    </>
  );
};

export default CopyDataManager;
